
export default {
    messages: {},
    attachments: {},
    discussions: {},
    discussionTypes: {
        10: "Common",
        20: "Managers",
        30: "Supervisors"
    }
}
